<script setup lang="ts">
import UIKit, { type TIconType } from '@pocketprep/ui-kit'

const { Icon } = UIKit

const props = withDefaults(
    defineProps<{
        title: string
        icon: TIconType
        loadingTitle?: boolean
        flagged?: boolean
    }>(),
    { loadingTitle: false, flagged: false }
)
</script>

<template>
    <div class="section-head">
        <div
            class="section-head__title"
            :class="{
                'section-head__title--flagged': props.flagged === true
            }"
        >
            <Icon
                v-if="!props.loadingTitle"
                class="section-head__title-icon"
                :type="props.icon"
            />
            <div
                v-if="!props.loadingTitle"
                v-html="props.title"
            />
        </div>
        <slot />
    </div>
</template>

<style lang="scss" scoped>


.section-head {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    color: $slate-01;
    font-size: 14px;
    line-height: 19px;
    padding: 10px 0;
    border-bottom: 1px solid $gray-divider;

    .section-head__title {
        color: $brand-black;
        font-size: 14px;
        line-height: 19px;
        display: flex;
        font-weight: 600;
        align-items: center;
        flex: 2;

        &--flagged {
            font-size: 15px;
            line-height: 18px;
        }

        &:deep(span) {
            font-weight: 400;
        }

        .section-head__title-icon {
            display: inline-block;
            margin-right: 5px;
            height: 23px;
            width: 23px;
        }
    }
}
</style>
